export default "__VITE_ASSET__C1T2NhdS__"